import(/* webpackMode: "eager" */ "/workspace/src/app/[locale]/error.tsx");
